export default {"src":"/_next/static/media/zel.6a9fd1f1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};